import type { PageType } from '@shared/types/utils';

import PageTypes from '@shared/constants/page-types';

export const EVENT_TYPE: Partial<{ [key in PageType]: string }> = {
  [PageTypes.DETAILS]: 'hotel_details_loaded',
  [PageTypes.SEARCH]: 'hotel_search_loaded',
};

export const namespace = 'HOTEL_FUNNEL';

export const FEATURE_TYPE = {
  HOTEL_DAYVIEW_DYNAMIC_SEARCH: 'hotel_dayview_dynamic_search',
};

export const FEATURE_EVENT = {
  [FEATURE_TYPE.HOTEL_DAYVIEW_DYNAMIC_SEARCH]: 'hotel_dayview_search_loaded',
};
